import { Navigate } from 'react-router-dom';
import { getAuthToken, getCurrentUser } from '../../../utils/authHelpers';

const ProtectedRoute = ({ children, allowedRole }) => {
  const token = getAuthToken();
  const user = getCurrentUser();

  if (!token || !user) return <Navigate to="/login" replace />;

  if (allowedRole && user !== allowedRole) {
    return <Navigate to={user === 'employee' ? '/jobseeker/dashboard' : '/dashboard'} replace />;
  }

  return children;
};

export default ProtectedRoute;
